module.exports = __webpack_public_path__ + "static/media/19da825baec74cbfc40d97a580d2aa62_html_f10f20fa7f0b763b.c152dcc4.png";